import { render, staticRenderFns } from "./ClientIncomingRegionReportComponent.vue?vue&type=template&id=55e20f68&scoped=true"
import script from "./ClientIncomingRegionReportComponent.vue?vue&type=script&lang=js"
export * from "./ClientIncomingRegionReportComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientIncomingRegionReportComponent.vue?vue&type=style&index=0&id=55e20f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e20f68",
  null
  
)

export default component.exports